// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".style_title__v9Dv3 {\n  font-size: 30px;\n  font-weight: bold;\n  min-height: 20px;\n}\n", "",{"version":3,"sources":["webpack://./src/ui/screens/SurveysCreateV2/CreateForm/ConsentSteps/Step/style.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB","sourcesContent":[".title {\n  font-size: 30px;\n  font-weight: bold;\n  min-height: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": "style_title__v9Dv3"
};
export default ___CSS_LOADER_EXPORT___;
